<div class="modal-header border-0 pb-0">
  <h4 class="modal-title fw-bold">
    <i class="fas fa-sign-out-alt me-2 text-primary"></i>
    Spiel verlassen
  </h4>
</div>

<div class="modal-body text-center py-4">
  <i class="fas fa-exclamation-triangle fa-4x mb-4 text-primary"></i>
  <h5 class="mb-3">Willst du das Spiel wirklich verlassen?</h5>
</div>

<div class="modal-footer border-0 pt-0">
  <button type="button" uiButton="neutral" class="me-2" (click)="cancel()">
    <i class="fas fa-times"></i>
    NEIN
  </button>
  <button type="button" uiButton (click)="confirm()">
    <i class="fas fa-check"></i>
    JA
  </button>
</div>
